module.exports = __webpack_public_path__ + "static/img/5.fa632be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/5.png
// module id = U2af
// module chunks = 0